module.exports = __webpack_public_path__ + "static/media/RA3S.dcc5079b.gif";